import { gql } from '@apollo/client';

export const queryTransactionAccount = gql`
  query fetchTransactionAccountSearch(
    $query: String!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    searchForTransactionAccount(query: $query, searchOptions: $searchOptions, filterOptions: $filterOptions) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        displayName
        id
        programLevelGlobal
        partnerDiscountTier
        defaultPaymentMethod {
          id
          type
          default
          paymentIssue
          hasLinkedSubscriptions
        }
        transactionAccountNumber
        billingAdmins {
          totalCount
          nodes {
            fullName
            email
          }
        }
        billToPartyPricingEligibilty
        billToParty {
          taxId
          addressLine1
          addressLine2
          state
          city
          country
          postcode
        }
      }
    }
  }
`;
